module.exports = __webpack_public_path__ + "media/St 4-EMU-question.3ca17104.wav";